import { AppState } from "features";
import { createSelector } from "reselect";

export const getGroupListState = ({ groups: { list } }: AppState) => list;

export const getGroupList = createSelector(getGroupListState, (groupList) =>
    groupList.status === "loaded" ? groupList.data : []
);
